<template>
  <div>
    <img
      v-if="useS3Icon"
      :class="$style.emptyIcon"
      role="presentation"
      :src="S3BucketAddress + icon"
    >
    <component
      :is="icon"
      v-else
      :class="$style.emptyIcon"
    />
    <p>
      {{ message }}
    </p>
    <a
      :class="$style.emptyMessageLink"
      href="#"
      @click.prevent="$emit('navigationMethod')"
    >
      {{ linkText }}
    </a>
  </div>
</template>

<script>
import { S3BucketAddress } from 'client/util/Constants/ApplicationConstants';

export default {
  name: 'ZeroState',

  props: {
    icon: {
      type: [Object, String],
      default: undefined,
    },
    linkText: {
      type: String,
      default: 'Click to Add',
    },
    message: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    S3BucketAddress,
  }),

  computed: {
    useS3Icon() {
      return typeof this.icon === 'string';
    },
  },
};
</script>

<style module>
.emptyIcon {
  max-width: 60px;
}

.emptyMessageLink {
  color: jcInformationalBase;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
}

</style>
